var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"bg-white py-4 px-5",attrs:{"rounded":"lg"}},[_c('p',{staticClass:"text-uppercase text-h4"},[_vm._v("Recipient")]),_c('recip')],1)}
var staticRenderFns = []

export { render, staticRenderFns }